import React from "react";
import { Redirect } from "react-router-dom";

const Settings = () => <Redirect to="/dashboard/settings/products" />;

export default Settings;
